import React, { useState } from 'react'
import { H3, H6 } from '../../../../../../../../../../../../Styles/typography'
import { Collapse, Container, List, ListItem } from '@material-ui/core'

const data = [
  {
    question: 'Is this a live class?',
    answer:
      'No. This is a pre-recorded course. There might be a live session to clear your doubts offered only to those who buy this course.',
  },
  {
    question: 'Will I lose access to this after certain period of time?',
    answer:
      'No You can access this course whenever you would like to without the fear of losing access. ',
  },
  {
    question: 'Can I download the course?',
    answer:
      "No. To curb piracy, we don't allow downloading any of the courses. You can access it anytime, anywhere via LivDemy. ",
  },
  {
    question: 'Can we view the course on Phone?',
    answer:
      'Yes. You can access the course via the m.livdemy.com website on your phones and iPads.',
  },
  {
    question: 'I am new to music. Can I take this course?',
    answer:
      'We would recommend you have some working knowledge of music before you take this course.',
  },
  {
    question: 'I have forgotten my Username/Password',
    answer:
      'If you have forgotten your password or your password is not working, click on "forgot password". next to login in the upper right corner of the website. A link to reset your password will be sent to your registered email ID. If you do not receive the email, check your spam/junk mail folder.',
  },
]

const Faq = () => {
  const [isOpen, open] = useState(-1)
  return (
    <div className='faq'>
      <H3>Frequently Asked Questions</H3>

      <List>
        {data.map(({ question, answer }, index) => (
          <ListItem
            onClick={() => open(index === isOpen ? -1 : index)}
            key={`faq-item-${index}`}
          >
            <Container>
              <H6 classname='question'>
                <span className='index'>{index + 1}.</span>
                <span className='text'>{question}</span>
                <div
                  className={'arrow' + (index === isOpen ? ' expanded' : '')}
                />
              </H6>
              <Collapse in={index === isOpen}>
                <div className='answer'>{answer}</div>
              </Collapse>
            </Container>
          </ListItem>
        ))}
      </List>
    </div>
  )
}

export default Faq
